// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5066":"2b367e42","5478":"01608ce6"}[chunkId] + ".chunk.css";
};